import { Account } from "../../../services/cloudchipr.api";

export const nonDeletedAccountsCombiner = (
  accounts: Account[] | null,
): Account[] | null => {
  return accounts?.filter((a) => a.status !== "deleted") ?? null;
};
